import ContractDetailView from '../views/DetailViews/ContractDetails/ContractDetailView'
import ScaleTicketsDetailView from '../views/DetailViews/ScaleTickets/ScaleTicketsDetailView'
import CompanyDetailView from '../views/DetailViews/Company/CompanyDetailView'
import WelcomeView from '../views/Welcome/WelcomeView'
import UpdateProfileView from '../views/UpdateProfile/UpdateProfileView'
import LoginView from '../views/Login/LoginView'
import NewUserView from '../views/NewUser/NewUserView'
import ContractDashboard from '../views/ContractDashboard/ContractDashboard'
import Company from '../views/Company/Company'
import UserDetailView from '../views/DetailViews/User/UserDetailView'
import CreateProductionPlanView from '../views/DetailViews/ProductionPlan/CreateProductionPlanView'
import EditProductionPlanView from '../views/DetailViews/ProductionPlan/EditProductionPlanView'
import ProductionPlanDetailView from '../views/DetailViews/ProductionPlan/ProductionPlanDetailView'
import Admin from '../views/Admin/Admin'
import SignUpView from '../views/SignUp/SignUp'
import SearchView from '../views/Search/SearchView'
import DocUploader from '../views/DocUploader/DocUploader'
import ContractPDFView from '../views/DetailViews/ContractPDF/ContractPDFView'
import SignContractView from '../views/Contracts/SignContractView'
import SignedOrApprovedView from '../views/Contracts/SignedOrApprovedView'
import MasterAgreementPDFView from '../views/DetailViews/ProductionPlan/MasterAgreementPDFView'
import ForgotPasswordView from '../views/Login/ForgotPasswordView'
import PageNotFound from '../views/PageNotFound/PageNotFound'
import CreateContractView from '../views/NewContract/CreateContractView'
import UploadScaleTicketView from '../views/DetailViews/UploadScaleTicket/UploadScaleTicketDetailView'
import UploadCompanyTrainingView from '../views/Admin/UploadCompanyTraining/UploadCompanyTrainingView'
import UploadCompanyTrainingVideoView from '../views/Admin/UploadCompanyTrainingVideo/UploadCompanyTrainingVideoView'
import AddCompanyProgramsView from '../views/Admin/AddCompanyPrograms/AddCompanyProgramsView'
import StewardshipDetailView from '../views/DetailViews/Stewardship/StewardshipDetailView'
import Reports from '../views/Reports/Reports'
import UploadAccountLeads from '../views/Admin/UploadAccountLeads/UploadAccountLeads'

export const baseURL = ''
const LoginRoute = {
  path: `${baseURL}/login`,
  title: 'login',
  displayName: 'Login',
  component: LoginView
}
const LoginRouteWithParam = {
  path: `${baseURL}/login/:login_hash`,
  title: 'login',
  displayName: 'Login',
  component: LoginView
}

const ForgotPasswordRoute = {
  path: `${baseURL}/forgot-password`,
  title: 'forgot-password',
  displayName: 'Forgot Password',
  component: ForgotPasswordView
}

const SignUpRoute = {
  path: `${baseURL}/sign-up`,
  title: 'signUp',
  displayName: 'Sign Up',
  component: SignUpView
}

export const loginRoutes = [
  LoginRouteWithParam,
  LoginRoute,
  SignUpRoute,
  ForgotPasswordRoute
]

const DocUploaderRoute = {
  path: `${baseURL}/docUploader`,
  title: 'docUploader',
  displayName: 'Documet Upoloader',
  component: DocUploader
}

const WelcomeRoute = {
  path: `${baseURL}/welcome`,
  title: 'welcome',
  displayName: 'Welcome',
  component: WelcomeView
}
const NewUserRoute = {
  path: `${baseURL}/new-user`,
  title: 'new-user',
  displayName: 'New User',
  component: NewUserView
}
const UserDetailRoute = {
  path: `${baseURL}/company/:company_id/user/:user_id`,
  title: 'user-detail-view',
  displayName: 'User Detail View',
  component: UserDetailView
}

const UpdateProfileRoute = {
  path: `${baseURL}/update-profile`,
  title: 'update_profile',
  displayName: 'Update Profile',
  component: UpdateProfileView
}

const SearchRoute = {
  path: `${baseURL}/search`,
  title: 'search',
  displayName: 'Search',
  component: SearchView
}

const CreateProductionPlanRoute = {
  path: `${baseURL}/company/:company_id/production-plan/create`,
  title: 'create-production-plan',
  displayname: 'Create Production Plan',
  component: CreateProductionPlanView
}
const EditProductionPlanRoute = {
  path: `${baseURL}/company/:company_id/production-plan/edit/:production_plan_id`,
  title: 'edit-production-plan',
  displayname: 'Edit Production Plan',
  component: EditProductionPlanView
}
const ViewProductionPlanRoute = {
  path: `${baseURL}/company/:company_id/production-plan/view/:production_plan_id`,
  title: 'production-plan',
  displayname: 'View Production Plan',
  component: ProductionPlanDetailView
}

const ViewMasterAgreementRoute = {
  path: `${baseURL}/company/:company_id/master-agreement/:contract_template_id`,
  title: 'master-agreement',
  displayname: 'View Master Agreement',
  component: MasterAgreementPDFView
}

const PageNotFoundRoute = {
  path: `${baseURL}/404`,
  title: 'page-not-found',
  displayName: 'Page not found',
  component: PageNotFound
}

export const otherRoutes = [
  DocUploaderRoute,
  WelcomeRoute,
  NewUserRoute,
  UpdateProfileRoute,
  UserDetailRoute,
  SearchRoute,
  CreateProductionPlanRoute,
  EditProductionPlanRoute,
  ViewProductionPlanRoute,
  SignUpRoute,
  ViewMasterAgreementRoute,
  PageNotFoundRoute
]

export const routes = [
  {
    path: `${baseURL}/dashboard`,
    title: 'dashboard',
    displayName: 'Dashboard',
    component: ContractDashboard,
    routes: [
      // {
      //   path: `${baseURL}/contracts/new-contract`,
      //   title: 'new-contract-view',
      //   displayname: 'New Contract',
      //   component: CreateContractView
      // },
      {
        path: `${baseURL}/contracts/complete`,
        title: 'contracts-detail-view',
        displayName: 'Contract Sign Success',
        component: SignedOrApprovedView
      },
      {
        path: `${baseURL}/company/:company_id/contracts/sign-pdf/:contract_id`,
        title: 'contracts-sign-view',
        displayName: 'Contract Sign View',
        component: SignContractView
      },
      {
        path: `${baseURL}/company/:company_id/contracts/view-pdf/:contract_id`,
        title: 'contract-view-pdf',
        displayname: 'Contract PDF View',
        component: ContractPDFView
      },
      {
        path: `${baseURL}/company/:company_id/contracts/amend-contract/:contract_id`,
        title: 'amend-contract-view',
        displayname: 'Amend Contract',
        component: CreateContractView
      },
      {
        path: `${baseURL}/company/:company_id/contracts/:contract_id`,
        title: 'contracts-detail-view',
        displayname: 'Contracts Detail View',
        component: ContractDetailView
      },
      {
        path: `${baseURL}/company/:company_id/stewardship/:stewardship_activity_id`,
        title: 'stewardship-detail-view',
        displayname: 'Stewardship Detail View',
        component: StewardshipDetailView
      },
      {
        path: `${baseURL}/company/:company_id/upload-scale-ticket/:production_plan_id`,
        title: 'scale-ticket-detail-view',
        displayname: 'Scale Ticket Detail View',
        component: UploadScaleTicketView
      },
      {
        path: `${baseURL}/company/upload-companies-training`,
        title: 'Company-Training-View',
        displayname: 'Company Training View',
        component: UploadCompanyTrainingView
      },
      {
        path: `${baseURL}/company/upload-training-video`,
        title: 'Company-Training-Video',
        displayname: 'Company Training Video',
        component: UploadCompanyTrainingVideoView
      },
      {
        path: `${baseURL}/company/upload-account-leads`,
        title: 'Upload-Account-Leads',
        displayname: 'Upload Account Leads',
        component: UploadAccountLeads
      },
      {
        path: `${baseURL}/company/:company_id/scale-tickets/:scale_year`,
        title: 'scale-tickets-detail-view',
        displayname: 'Scale Tickets Detail View',
        component: ScaleTicketsDetailView
      },
      {
        path: `${baseURL}/company/programs`,
        title: 'Programs',
        displayname: 'Programs',
        component: AddCompanyProgramsView
      }
    ]
  },
  {
    path: `${baseURL}/company`,
    title: 'company',
    displayName: 'Company',
    component: Company,
    routes: [
      {
        path: `${baseURL}/company/:company_id`,
        title: 'resellers-detail-view',
        displayname: 'Company Detail View',
        component: CompanyDetailView
      }
    ]
  },
  {
    path: `${baseURL}/admin`,
    title: 'admin',
    displayName: 'Admin',
    component: Admin,
    routes: []
  },
  {
    path: `${baseURL}/reports`,
    title: 'reports',
    displayName: 'Reports',
    component: Reports,
    routes: []
  }
]

export default routes
